import { render, staticRenderFns } from "./ExtraServices.vue?vue&type=template&id=84554ee8&scoped=true&"
import script from "./ExtraServices.vue?vue&type=script&lang=ts&"
export * from "./ExtraServices.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraServices.vue?vue&type=style&index=0&id=84554ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84554ee8",
  null
  
)

export default component.exports